
export default function Hero() {
  const scrollToProducts = () => {
    const productsSection = document.getElementById('produtos');
    if (productsSection) {
      productsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative h-screen w-full overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/0ead3606a901afefec3e45e480dbc8cd.jpg"
          alt="Hero"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      </div>

      <div className="relative h-full flex items-end pb-16 md:pb-32 px-6 md:px-20">
        <div className="max-w-3xl w-full">
          <div className="inline-block mb-4 md:mb-6 px-3 md:px-4 py-1.5 md:py-2 border-2 border-white rounded-full">
            <span className="text-white text-xs md:text-sm font-medium">Nova Coleção 2026</span>
          </div>
          
          <h1 className="text-4xl md:text-7xl font-light text-white mb-4 md:mb-6 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
            Veja o mundo com<br />clareza e estilo
          </h1>
          
          <p className="text-white/80 text-base md:text-lg mb-6 md:mb-8 max-w-xl">
            Tecnologia avançada em lentes e armações exclusivas para você enxergar melhor e viver com mais confiança
          </p>
          
          <button 
            onClick={scrollToProducts}
            className="bg-teal-500 hover:bg-teal-600 text-white px-6 md:px-8 py-3 md:py-4 rounded-full text-sm md:text-base font-medium transition-all shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap flex items-center gap-2 md:gap-3"
          >
            Explorar Coleção
            <i className="ri-arrow-right-line text-lg md:text-xl"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
